/**
 * DIT-513 — reading back a time this browser stored earlier.
 *
 * The attribution record and the once-only event keys both store `Date.now()` and
 * measure a window from it later. A time far ahead of the clock was written while the
 * clock was wrong — a device set a year ahead and since corrected — and a window
 * counted from it would never end. A little ahead is ordinary: clocks drift minutes
 * fast and are synced back, and treating that as corruption would throw away a real
 * journey or forget a spent key. A day separates the two.
 */
export const CLOCK_TOLERANCE_MS = 24 * 60 * 60 * 1000;

/** Whether a stored time is further ahead of the clock than drift explains. */
export function isDatedAhead(at: number): boolean {
  return at - Date.now() > CLOCK_TOLERANCE_MS;
}
